module.exports = __webpack_public_path__ + "static/media/industry.d8b1d86c.jpg";